import removeInternetHeaders from 'owa-mail-compose-store/lib/actions/removeInternetHeaders';
import setInternetHeaders from 'owa-mail-compose-store/lib/actions/setInternetHeaders';
import { ComposeViewState, ComposeOperation } from 'owa-mail-compose-store';
import { InternetHeaders } from 'owa-addins-core';
import { updateViewStateWithAnyMissingHeaders } from '../../utils/InternetHeaderUtils';

export const setInternetHeadersAdapter = (viewState: ComposeViewState) => (
    dictionary: InternetHeaders
) => {
    setInternetHeaders(viewState, dictionary);
};

export const removeInternetHeadersAdapter = (viewState: ComposeViewState) => async (
    headerNames: string[]
) => {
    if (viewState.operation === ComposeOperation.EditDraft) {
        await updateViewStateWithAnyMissingHeaders(viewState, headerNames);
    }
    removeInternetHeaders(viewState, headerNames);
};
